import { Api } from 'utils';

class ServiceService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/services/get',params),
		getJourneys: async (params?: any) => Api.createResponse('admin/services/get-journeys',params),
		create: async (params?: any) => Api.createResponse('admin/services/create',params),
		update: async (params?: any) => Api.createResponse('admin/services/update',params),
		delete: async (params?: any) => Api.createResponse('admin/services/delete',params),
		bulkDelete: async (params?: any) => Api.createResponse('admin/services/bulk-delete',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/services/change-status',params),
		getHolidays: async (params?: any) => Api.createResponse('admin/services/holidays',params),
		setHolidays: async (params?: any) => Api.createResponse('admin/services/set-holidays',params),
		getSpecialDays: async (params?: any) => Api.createResponse('admin/services/special-days',params),
		setSpecialDays: async (params?: any) => Api.createResponse('admin/services/set-special-days',params),
		getUrgent: async (params?: any) => Api.createResponse('admin/services/urgent',params),
		setUrgent: async (params?: any) => Api.createResponse('admin/services/set-urgent',params),
	}

}

export default ServiceService;